import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CountryNameDTO  {
    _originalTypeClassName = "zERP.BO.CountryNameDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CountryNameDTO.translate = translateService;
}
this.common = null;
this.CountryNameDTOKey = null;
this._key = this.CountryNameDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
common:any;
private _CountryNameDTOKey:any;
get CountryNameDTOKey(): any {
    return this._CountryNameDTOKey;
  }
set CountryNameDTOKey(value: any) {
    this._CountryNameDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CountryNameDTOKey == null || $this.CountryNameDTOKey == 0;
            }


}